import React from 'react';
import HelmetP from './app/providers/HelmetProvider';
import RouterP from './app/providers/RouterProvider';
import AppRoutes from './app/AppRoutes';
import { AuthProvider } from './features/auth/AuthContext';
import './index.css';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import ScrollRestoration from 'src/components/ScrollRestoration';
import { ToastProvider } from './shared/ui/toast/ToastProvider';

export default function App() {
    return (
        <HelmetP>
            <RouterP>
                <ScrollRestoration />
                <AuthProvider>
                    <QueryClientProvider client={queryClient}>
                        <ToastProvider>
                            <AppRoutes />
                        </ToastProvider>
                    </QueryClientProvider>
                </AuthProvider>
            </RouterP>
        </HelmetP>
    );
}
